import { useEffect } from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'
import CheckoutAddressList from './CheckoutAddressList'
import { setCustomerAddress, setBillingAddress, setUseShippingAsBilling } from './checkoutFunctions'

const CheckoutAddressPanel = ({
  addressType,
  addresses,
  useShippingAsBilling,
  setUseShippingAsBilling,
  allItemsDigital,
  ...props
}) => {

  const handleSelectAddress = (address, deselect = false) => {
    if (addressType === 'delivery') {
      props.setCustomerAddress(deselect ? {} : address).then(() => {
        // additionally set billing if same address checkbox is checked
        if (useShippingAsBilling) {
          props.setBillingAddress(address)
        }
      })
    } else if (addressType === 'billing') {
      props.setBillingAddress(deselect ? {} : address)
    }
  }

  // If only one address, set as selected (only for shipping)
  useEffect(() => {
    if (addresses.length === 1 && addressType === 'delivery') {
      handleSelectAddress(addresses[0])
    }
  }, [])

  // un-check use shipping as billing under certain conditions
  useEffect(() => {
    if (
      (props.manageAddresses === true && useShippingAsBilling === true) ||
      (props.newAddressMode === true && useShippingAsBilling === true)
    ) {
      if (addressType === 'delivery') {
        setUseShippingAsBilling(false)
      }
    }
  }, [props.newAddressMode, props.manageAddresses])

  return (
    <Row>
      <Col xs="12" style={{ paddingBottom: '0px' }}>
        <CheckoutAddressList
          addresses={addresses}
          addressType={addressType}
          handleSelectAddress={handleSelectAddress}
          selectedAddress={addressType === 'billing' ? props.selectedBillingAddress : props.selectedCustomerAddress}
          useShippingAsBilling={useShippingAsBilling}
          allItemsAreDigital={allItemsDigital}
        />
      </Col>
    </Row>
  )
}

const mapStateToProps = state => {
  return {
    requireBillingAddressForFreeOrders: state.storeViews.current.require_billing_address_for_free_orders,
    selectedDeliveryAddress: state.checkout.selectedDeliveryAddress,
    managed_customer_addresses: state.managed_customer_addresses,
    customer_addresses: state.customer_addresses,
    selectedCustomerAddress: state.checkout.selectedCustomerAddress,
    selectedBillingAddress: state.checkout.selectedBillingAddress,
    youPay: state.checkout.youPay,
    portal: state.portal,
    useShippingAsBilling: state.checkout.useShippingAsBilling
  }
}

export default connect(mapStateToProps, {
  setCustomerAddress,
  setBillingAddress,
  setUseShippingAsBilling
})(CheckoutAddressPanel)
